/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Question",
  size: 20
}

const SvgQuestion = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.1} cx={10} cy={10} r={9} />
    <circle cx={10.44} cy={14.42} r={1.05} />
    <path
      fill="none"
      strokeWidth={1.2}
      d="M8.17 7.79c0-3.04 4.55-3.06 4.55-.07 0 .95-.91 1.43-1.49 2.03-.48.49-.72.98-.78 1.65-.01.13-.02.24-.02.35"
    />
  </Svg>
)

SvgQuestion.defaultProps = defaultProps
export default SvgQuestion
